import api from "../../api/axios";

export const getAllProviders = async (params) => {
  let response = await api.get("/providers", { params });
  return response.data;
};
export const addProvider = async (data) => {
  let response = await api.post("/providers", data);
  return response.data;
};

export const updateProvider = async (id, data) => {
  let response = await api.put(`/providers/${id}`, data);
  return response.data;
};
